<div
  class="tag-button modern-tag-button"
  [ngClass]="{
    'ddc-home-card-light-5': _isLightTheme,
    'ddc-home-card-dark-5': _isDarkTheme,
    'ddc-home-card-paper-5': _isPaperTheme,
  }"
>
  <div class="button-content">
    <mat-icon class="tag-icon">tag</mat-icon>
    <span class="tag-label">{{ _label }}</span>
  </div>
</div>
